import { Component, OnInit } from "@angular/core";
import "../../../assets/svg-icons/ic-svane.svg";
import { TextContentService } from "../../services/text-content/text-content.service";

@Component({
  selector: "app-footer",
  styleUrls: ["./footer.component.scss"],
  templateUrl: "./footer.component.html",
})
export class FooterComponent implements OnInit {
  private footerCredits: Element;

  constructor(
    private textContentService: TextContentService,
  ) { }

  public ngOnInit() {
    const swanIcon = document.createElement("span");
    swanIcon.innerHTML = `
      <svg
        [attr.xmlns:xlink]="'http://www.w3.org/1999/xlink'"
        [attr.xmlns]="'http://www.w3.org/2000/svg'"
        [attr.height]="8"
        [attr.width]="8"
        [attr.class]="">
        <use [attr.xlink:href]="#ic-svane" />
      </svg>
    `;
    this.footerCredits = this.textContentService.interpolate("footerCredits", swanIcon);

  }
}



// WEBPACK FOOTER //
// ./src/app/partials/footer/footer.component.ts